/**
 * Created by carlhaynes on 9/25/17.
 */
import React, { Component } from 'react';
import './Register.css';
import { Grid, Row, Col, PageHeader } from 'react-bootstrap';
import {auth, isRealUser} from "../App";
import {withRouter} from 'react-router-dom'

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: null
    };

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
  }

  handleEmailChange(event) {
    this.setState({email: event.target.value});
  }
  handlePasswordChange(event) {
    this.setState({password: event.target.value});
  }

  handleSubmit(event) {
    event.preventDefault();

    auth.createUserWithEmailAndPassword(this.state.email, this.state.password).catch((error) => {
      // Handle Errors here.
     // var errorCode = error.code;
      var errorMessage = error.message;
      this.setState({error: errorMessage});
      console.log("error: " + errorMessage);
    }
    ).then((user) =>  {
      if (user) {

        // create db record






        this.props.history.push('/');
      }
    });




    // //console.log('A login was submitted: ' + this.state.email + ' / ' + this.state.password);
    // auth.signInWithEmailAndPassword(this.state.email, this.state.password).catch(() => function(error) {
    //   // Handle Errors here.
    //   // var errorCode = error.code;
    //   var errorMessage = error.message;
    //
    //   console.log("error: " + error.message);
    //   this.setState({error: errorMessage});
    // });


  }

  handleAlertDismiss() {
    this.setState({error: null});
  }

  render() {

    const registerForm = (
      <form type="POST" onSubmit={this.handleSubmit}>
        {(this.state.error)
          ?<div><span className='text-danger'>{this.state.error}</span></div>
          :''
        }
        <div className="formGroup row">
          <Col xs={1}>
            <label htmlFor="emailField" className="col-form-label">
              Email:
            </label>
          </Col>

          <Col xs={11}>
            <input id="emailField" type="email" name='email' value={this.state.email} onChange={this.handleEmailChange} placeholder="Email" />
          </Col>
        </div>

        <div className="Login-formdiv"></div>


        <div className="formGroup row">
          <Col xs={2} md={1}>
            <label htmlFor="emailField" className="col-2 col-form-label">
              Password:
            </label>
          </Col>
          <Col xs={12} md={11}>
            <input id="passwordField" type="password" name='password' value={this.state.password} onChange={this.handlePasswordChange} />
          </Col>
        </div>

        <div className="Register-formdiv"></div>

        <div className="formGroup row">
          <Col smOffset={2}>
            <input className="btn btn-primary" type="submit" value="Submit" />
          </Col>
        </div>

        <div className="Register-formdiv"></div>

      </form>
    );

    return (
      <Grid>
        <Row>
          <PageHeader>Register <small>Please enter an email and password</small></PageHeader>
        </Row>
        <Row>
          {(isRealUser())
            ? 'Already logged in'
            : registerForm
          }
        </Row>
        <Row>
          <a href="/login">Already have an account? Log in here</a>
        </Row>

      </Grid>
    );
  }
}

export default withRouter(Register);



// WEBPACK FOOTER //
// ./src/pages/Register.jsx